const schemeRE = /^\w+:///

export default function addHttpToUrlIfMissing (url) {
  if (schemeRE.test(url)) {
    return url
  }
  return 'http://' + url
}
